import { Injectable, signal } from '@angular/core';

/**
 * Stores a short-lived bearer token supplied via the ?token= query parameter.
 * The token is held in memory only - never written to storage.
 * It is captured by the route guard on first navigation and used by the
 * auth interceptor in place of a Keycloak/host-application token.
 */
@Injectable({ providedIn: 'root' })
export class QueryParamTokenService {
  private readonly token = signal<string | null>(null);

  setToken(token: string): void {
    this.token.set(token);
  }

  getToken(): string | null {
    return this.token();
  }

  clearToken(): void {
    this.token.set(null);
  }

  hasToken(): boolean {
    return this.token() !== null;
  }
}
